import { Checkbox } from '@ironscales/design-system'

export default Checkbox

export const SIZES = Checkbox.SIZES
